
import { Vue, Component, Prop } from 'vue-property-decorator'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'
import ModalPixels from '~/components/common/modals/success-modal/ModalPixels.vue'

interface TrackingOptions {
  hasOffersTransactionId: number;
  isFreeTrial: boolean;
  isFreemium: boolean;
}

@Component({
  name: 'SuccessModal',
  components: {
    CloseCrossCtrl,
    ModalPixels
  }
})
export default class SuccessModal extends Vue {
  @Prop({ type: String, required: true }) content!: string
  @Prop({ type: String, required: true }) gender!: string
  @Prop({ type: Object, default: null }) tracking: TrackingOptions | null

  mounted() {
    this.successModalTrack()
  }

  successModalTrack() {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'CongratulationsPopup'
    })
  }
}
